<template>

  <Toast position="top-right" />  
    <div :class="containerClass" :data-theme="colorScheme" @click="onDocumentClick($event)">

        <div class="layout-content-wrapper">
            <Dialog :visible="$store.state.generic.loading" :modal="true" :closable="false" >
                <ProgressSpinner mode="indeterminate" />
            </Dialog>
            <AppTopBar v-if="isMenuVisible" :topbarNotificationMenuActive="topbarNotificationMenuActive" :topbarUserMenuActive="topbarUserMenuActive"
                       :layoutMode="layoutMode" :menu="menu" :menuActive="menuActive" :staticMenuMobileActive='staticMenuMobileActive'
                       @menu-click="onMenuClick" @menuitem-click="onMenuItemClick" @root-menuitem-click="onRootMenuItemClick"
                       @menu-button-click="onMenuButtonClick" @search-click="toggleSearch" @topbar-notification="onTopbarNotificationMenuButtonClick"
                       @topbar-user-menu="onTopbarUserMenuButtonClick" @right-menu-click="onRightMenuButtonClick" @right-menubutton-click="onRightMenuButtonClick"></AppTopBar>

            <div class="layout-content">

                <div class="layout-breadcrumb viewname" style="text-transform: uppercase">
                    <template v-if="$route.meta.breadcrumb">
                        <span>{{$store.state.security.navbarTitle ? $t($store.state.security.navbarTitle): ''}}</span>
                    </template>
                </div>
                <router-view :key="$route.fullPath"/>
            </div>
            <!--<AppFooter/>-->
        </div>

        <AppRightMenu :rightMenuActive="rightMenuActive" @right-menu-click="onRightMenuClick"></AppRightMenu>

        <AppConfig v-model:configActive="configActive" v-model:layoutMode="layoutMode" v-model:menuTheme="menuTheme" v-model:colorScheme="colorScheme" @config-click="onConfigClick" @config-button-click="onConfigButtonClick"></AppConfig>

        <AppSearch :searchActive="searchActive" @search-click="onSearchClick" @search-hide="onSearchHide"/>

        <ConfirmDialog />
        <ConfirmPopup group="local" />
    </div>
</template>

<script>
import ConfirmDialog from 'primevue/confirmdialog';
import EventBus from './event-bus';
import AppTopBar from "./AppTopbar";
import AppConfig from "./AppConfig";
//import AppFooter from "./AppFooter";
import AppSearch from "./AppSearch";
import AppRightMenu from "./AppRightMenu";
import SecurityService from './services/security';
import NotificationService from './services/notifications';
import Toast from 'primevue/toast';
import store from './store';
import ProgressSpinner from 'primevue/progressspinner';
import Dialog from 'primevue/dialog';

export default {
    data() {
        return {
            menuActive: false,
            layoutMode: localStorage.getItem('layoutMode') ?? "static",
            colorScheme: localStorage.getItem('colorScheme') ?? "light",
            menuTheme: "layout-sidebar-darkgray",
            overlayMenuActive: false,
            staticMenuDesktopInactive: false,
            staticMenuMobileActive: false,
            menuClick: false,
            searchActive: false,
            searchClick: false,
            userMenuClick: false,
            topbarUserMenuActive: false,
            notificationMenuClick: false,
            topbarNotificationMenuActive: false,
            rightMenuClick: false,
            rightMenuActive: false,
            configActive: false,
            configClick: false,
            menu: [],
        };
    },
    computed: {
        isMenuVisible(){
            return store.state.security.user;
        },
        containerClass() {
            return [
                "layout-wrapper",
                {
                    "layout-overlay": this.layoutMode === "overlay",
                    "layout-static": this.layoutMode === "static",
                    "layout-slim": this.layoutMode === "slim",
                    'layout-horizontal': this.layoutMode === 'horizontal',
                    "layout-sidebar-dim": this.colorScheme === "dim",
                    "layout-sidebar-dark": this.colorScheme === "dark",
                    "layout-overlay-active": this.overlayMenuActive,
                    "layout-mobile-active": this.staticMenuMobileActive,
                    "layout-static-inactive": this.staticMenuDesktopInactive && this.layoutMode === "static",
                    "p-input-filled": this.$primevue.config.inputStyle === "filled",
                    "p-ripple-disabled": !this.$primevue.config.ripple,
                },
                this.colorScheme === "light" ? this.menuTheme : "",
            ];
        },
        storeLanguage(){
            return this.$store.state.security.language;
        },
    },
    components: {
        AppTopBar,
        AppSearch,
        AppRightMenu,
        Dialog,
        ProgressSpinner,
        Toast,
        AppConfig,
        ConfirmDialog
    },
    watch: {
        $route() {
            this.menuActive = false;
            this.$toast.removeAllGroups();
        },
    },
    methods: {
        onDocumentClick() {
            if (!this.searchClick && this.searchActive) {
                this.onSearchHide();
            }

            if (!this.userMenuClick) {
                this.topbarUserMenuActive = false;
            }

            if (!this.notificationMenuClick) {
                this.topbarNotificationMenuActive = false;
            }

            if (!this.rightMenuClick) {
                this.rightMenuActive = false;
            }

            if (!this.menuClick) {
                if (this.isSlim() || this.isHorizontal()) {
					EventBus.emit('reset-active-index');
					this.menuActive = false;
                }

                if (this.overlayMenuActive || this.staticMenuMobileActive) {
                    this.hideOverlayMenu();
                }

                this.unblockBodyScroll();
            }

            if (this.configActive && !this.configClick) {
                this.configActive = false;
            }

            this.searchClick = false;
            this.configClick = false;
            this.userMenuClick = false;
            this.rightMenuClick = false;
            this.notificationMenuClick = false;
            this.menuClick = false;
        },
        onMenuClick() {
            this.menuClick = true;
        },
        onMenuButtonClick(event) {
            this.menuClick = true;
            this.topbarUserMenuActive = false;
            this.topbarNotificationMenuActive = false;
            this.rightMenuActive = false;

            if (this.isOverlay()) {
                this.overlayMenuActive = !this.overlayMenuActive;
            }

            if (this.isDesktop()) {
                this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
            } else {
                this.staticMenuMobileActive = !this.staticMenuMobileActive;
                if (this.staticMenuMobileActive) {
                    this.blockBodyScroll();
                } else {
                    this.unblockBodyScroll();
                }
            }

            event.preventDefault();
        },
        onMenuItemClick(event) {
			if (!event.item.items) {
				EventBus.emit('reset-active-index');
				this.hideOverlayMenu();
			}
			if (!event.item.items && (this.isSlim() || this.isHorizontal())) {
                this.menuActive = false;
            }
        },
		onRootMenuItemClick() {
            this.menuActive = !this.menuActive;
        },
        onTopbarUserMenuButtonClick(event) {
            this.userMenuClick = true;
            this.topbarUserMenuActive = !this.topbarUserMenuActive;

            this.hideOverlayMenu();

            event.preventDefault();
        },
        onTopbarNotificationMenuButtonClick(event) {
            this.notificationMenuClick = true;
            this.topbarNotificationMenuActive = !this.topbarNotificationMenuActive;

            this.hideOverlayMenu();
            event.preventDefault();
        },
        toggleSearch() {
            this.searchActive = !this.searchActive;
            this.searchClick = true;
        },
        onSearchClick() {
            this.searchClick = true;
        },
        onSearchHide() {
            this.searchActive = false;
            this.searchClick = false;
        },
        onRightMenuClick() {
			this.rightMenuClick = true;
		},
        onRightMenuButtonClick(event) {
			this.rightMenuClick = true;
			this.rightMenuActive = !this.rightMenuActive;
			this.hideOverlayMenu();
			event.preventDefault();
		},
        onConfigClick() {
            this.configClick = true;
        },
        onConfigButtonClick() {
            this.configActive = !this.configActive;
            this.configClick = true;
        },
        hideOverlayMenu() {
            this.overlayMenuActive = false;
            this.staticMenuMobileActive = false;
            this.unblockBodyScroll();
        },
        blockBodyScroll() {
            if (document.body.classList) {
                document.body.classList.add('blocked-scroll');
            } else {
                document.body.className += ' blocked-scroll';
            }
        },
        unblockBodyScroll() {
            if (document.body.classList) {
                document.body.classList.remove('blocked-scroll');
            } else {
                document.body.className = document.body.className.replace(new RegExp('(^|\\b)' +
                    'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
            }
        },
        isSlim() {
            return this.layoutMode === "slim";
        },
        isHorizontal() {
            return this.layoutMode === "horizontal";
        },
        isOverlay() {
            return this.layoutMode === "overlay";
        },
        isDesktop() {
            return window.innerWidth > 1091;
        },
        createMenu(){
            let menu = this.menuItems;
            if(menu){
                let items = [];
                for(let i=0; i<menu.length; i++){
                    let item = {
                        label: menu[i].text,
                        icon: menu[i].icon,
                        items: []
                    };

                    for(let k=0; k<menu[i].items.length; k++){
                        let subItem = {
                            label: menu[i].items[k].text,
                        };

                        if(menu[i].items[k].items && menu[i].items[k].items.length > 0){
                            subItem.items = [];
                            for(let j=0; j<menu[i].items[k].items.length; j++){

                                let subSubItem = {
                                    label: menu[i].items[k].items[j].text,
                                    
                                };

                                if(menu[i].items[k].items[j].items && menu[i].items[k].items[j].items.length > 0){
                                    subSubItem.items = [];
                                    for(let a =0; a<menu[i].items[k].items[j].items.length; a++){
                                        subSubItem.items.push({
                                            label: menu[i].items[k].items[j].items[a].text,
                                            to : menu[i].items[k].items[j].items[a].link,
                                            icon : menu[i].items[k].items[j].items[a].icon,
                                            command : () => {
                                                this.openDrawer= false;
                                            }
                                        });
                                    }
                                }else{
                                    subSubItem.to = menu[i].items[k].items[j].link;
                                    subSubItem.icon = menu[i].items[k].items[j].icon;
                                    subSubItem.command = () => {
                                        this.openDrawer= false;
                                    }
                                }

                                subItem.items.push(subSubItem);
                            }
                        }else{
                            subItem.to = menu[i].items[k].link;
                            subItem.icon = menu[i].items[k].icon;
                            subItem.command = () => {
                                this.openDrawer= false;
                            }
                        }

                        item.items.push(subItem)
                    }

                    items.push(item);
                }
                this.$store.dispatch("security/setMenu", items);
                this.menu = items;
            }
        }
    },
    mounted(){
        this.selectedLanguage = this.$store.state.security.language;
        this.$i18n.changeLocale(this.selectedLanguage);
        if(this.$store.state.security.user){
        SecurityService.getApplicationMenu({}, response => {
            if(response.success){
                this.menuItems = response.data;
                this.createMenu();
            }
        });
        SecurityService.getUiPermissions({}, response => {
            if(response.success){
                this.$store.dispatch("security/setUiPermissions", response.data);
            }
        });
        NotificationService.getNotifications(response => {
            if(response.success){
            this.$store.dispatch("notifications/setNotifications", response.data);
            }
        }); 
    }
  },
};
</script>

<style lang="scss">
@import "App.scss";
</style>
